import React from 'react';
import MetersIndexPage from '../meters_index_page/MetersIndexPage';

export default function MetersActiveIndexPage() {
	return (
		<MetersIndexPage
			preAppliedFilters={{ isArchived: 'false' }}
			targetCollectionName="metersIndex"
		/>
	);
}
